import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { InlineGridField, InlineGrid } from '@components/form';

import { tasksFormHistoriesGridColumns } from '@modules/tasks/_tasksColumns';

const View: React.SFC<any> = () => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <InlineGridField
          component={InlineGrid}
          name="histories"
          columns={tasksFormHistoriesGridColumns}
          showCheckboxes={false}
          deleting={false}
          adding={false}
        />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/tasks/TasksFormHistories.tsx